/*
 * Restricted access block
 * Hide content unless use of terms of use are accepted
 * Works with multiple blocks
*/


class RestrictedAccess {
  /*
   * @param {object} config - class selectors configs
  */
  constructor( config = {
    container: '.restricted-access-block',
    acceptTermsButton: '.accept-terms',
    denyTermsButton: '.deny-terms',
    content: '.restricted-access-block__content',
    termsOfUse: '.restricted-access-block__terms-of-use'
  }) {
    this.restrictedAccess = document.querySelectorAll(config.container);
    this.classAcceptTermsButton = config.acceptTermsButton
    this.classDenyTermsButton = config.denyTermsButton
    this.classContent = config.content
    this.classTermsOfUse = config.termsOfUse
    this.contentBlocks = {} // holds the content sections
  }

  /*
    * @param {HTMLElement} container - restrictedAccess container
    * @return {object} - child HTMLElements 
  */
  childElements(container) {
    return {
      acceptTermsButton: container.querySelector(this.classAcceptTermsButton),
      denyTermsButton: container.querySelector(this.classDenyTermsButton),
      termsOfUse: container.querySelector(this.classTermsOfUse),
      content: container.querySelector(this.classContent)
    }
  }

  /*
   * Accept terms button click event
   * Show content and hide terms of use
   *
   * @param {HTMLElement} block - Content element
   * @param {HTMLElement} termsOfUse - Terms of use element
   * @param {number} index - Used to retive content
  */
  acceptTerms(block, termsOfUse, index) {
    if ( !block || !termsOfUse) {
      console.warn('HTMLElements not found')
      return
    }
    block.innerHTML = this.contentBlocks[index]
  }

  /* Deny terms button click event
   * Redirects user to url if found
   *
   * @param {event} event - click event
  */
  denyTerms(event) {
    const targetUrl = event.target.dataset.redirectUrl
    if (!targetUrl) {
      console.warn('No redirect url found')
      return
    }

    location.href = targetUrl // redirect to url
  }

  /*
   * Init Restricted Access block
  */
  init() {
    this.restrictedAccess.forEach( (block, index) => {
      const elements = this.childElements(block)
      const {denyTermsButton, acceptTermsButton, content, termsOfUse} = elements
      if (content) {
        content.classList.remove('d-none');
        this.contentBlocks[index] = content.innerHTML;
        content.remove()
      }
      if (acceptTermsButton) {
        acceptTermsButton.addEventListener('click', () => this.acceptTerms(block, termsOfUse, index), {once: true})
      }

      if (denyTermsButton) {
        denyTermsButton.addEventListener('click', this.denyTerms, {once: true})
      }
    })
  }
}

export default RestrictedAccess
